// Название места под ногами игрока — то, что HUD пишет в углу постоянно.
//
// Модуль чистый (ни React, ни мира), чтобы список можно было сверять тестом:
// он обязан покрывать каждую точку из WORLD_DESTINATIONS, иначе игрок,
// пришедший туда по карте, читает «ОТКРЫТОЕ МОРЕ». Проверяет
// scripts/world-places.test.mjs.
//
// Мир пересобран с нуля 2026-08-04: старые зоны (Пагода, CITY-01, Амстердам,
// Chromatic) снесены вместе с картами, врать игроку про несуществующие
// локации нельзя. Новые места добавляются сюда по мере постройки.
export const ISLAND_ZONES = [
  { world: 'ОСТРОВ ПРИБЫТИЯ', hint: 'арки ведут на острова', cx: 0, cz: 0, r: 56 },
  { world: 'ТОРГОВЫЙ КРУГ', hint: 'рынок под навесами', cx: 200, cz: 0, r: 50 },
  { world: 'ТИХАЯ РОЩА', hint: 'костёр, пруд, беседка', cx: 0, cz: 200, r: 50 },
  { world: 'ПОЛИГОН', hint: 'амфитеатр и паркур', cx: -200, cz: 0, r: 50 },
  // Квартал участков — не остров, а полоса земли к югу: два ряда участков
  // по x = ±80 между z = -164 и -266. Круг накрывает оба ряда и подход к ним.
  { world: 'КВАРТАЛ УЧАСТКОВ', hint: 'своя земля и стройка', cx: -11, cz: -209, r: 110 },
]

export const OPEN_SEA = { world: 'ОТКРЫТОЕ МОРЕ', hint: 'вернись к маяку' }

// Ближайшая по списку зона, накрывающая точку. Вне всех зон — открытое море.
export function zoneAt(x, z) {
  if (!Number.isFinite(x) || !Number.isFinite(z)) return OPEN_SEA
  const zone = ISLAND_ZONES.find(item => Math.hypot(x - item.cx, z - item.cz) <= item.r)
  return zone ? { world: zone.world, hint: zone.hint } : OPEN_SEA
}
